"use client";

/**
 * current route pathname is only available on the client side.
 * server components will need to access it through a new header that contains the url
 */

import { usePathname } from "next/navigation";

export type RoutePathname = {
  route: string;
};

function getRouteFromNextNavigation() {
  try {
    // @ts-ignore
    return usePathname();
  } catch (e) {
    return null;
  }
}

/**
 * Intelligently get the location data for the current page.
 *
 * We can get location from the next/navigation for client rendered pages.
 * And from the headers for server rendered pages.
 *
 */
export default function useRoutePathname(): RoutePathname {
  let route = getRouteFromNextNavigation();

  if (!route) {
    // TODO get URL from header
    route = "/";
  }

  return { route };
}
